import { getShareableCalendarMenuItems } from '../../utils/commandBarItemUtils';
import { DirectionalHint } from '@fluentui/react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { getCalendarColorScheme } from 'owa-calendar-color-resolver';
import { lazyShowCalendarSharingPermissionsDialog } from 'owa-calendar-sharing';
import { getCalculatedFolderIdByCalendarID, getShareableCalendars } from 'owa-calendar-cache';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { shareLabel } from 'owa-locstrings/lib/strings/sharelabel.locstring.json';

import styles from '../../components/CalendarModuleCommandBar.scss';

export function getSurfaceShareMenuItem() {
    const shareableCalendarMenuItems = getShareableCalendarMenuItems(
        styles.shareableCalendarMenuItem
    );
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(shareLabel),
        [FilterableMenuItemArgs.icon]: ControlIcons.Share,
        [FilterableMenuItemArgs.onClick]: showCalendarSharingDialog,
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.menuContent]: shareableCalendarMenuItems
            ? {
                  items: shareableCalendarMenuItems,
                  onMenuOpened: onShareButtonClicked,
                  directionalHint: DirectionalHint.bottomRightEdge,
              }
            : null,
        [FilterableMenuItemArgs.subMenuProps]: shareableCalendarMenuItems
            ? {
                  items: shareableCalendarMenuItems,
                  onMenuOpened: onShareButtonClicked,
                  directionalHint: DirectionalHint.bottomRightEdge,
              }
            : null,
    });
}

function onShareButtonClicked(): void {
    logUsage('SurfaceCommandBar_Share');
}

function showCalendarSharingDialog(ev: React.MouseEvent<HTMLDivElement>) {
    onShareButtonClicked();
    const shareableCalendars = getShareableCalendars();
    if (shareableCalendars.length == 1) {
        const calendarEntry = shareableCalendars[0];
        const calculatedFolderId = getCalculatedFolderIdByCalendarID(calendarEntry.calendarId.id);
        const calendarColorScheme = getCalendarColorScheme(calendarEntry.calendarId);
        const fontColor = calendarColorScheme.calPrimary;
        lazyShowCalendarSharingPermissionsDialog.importAndExecute(
            calculatedFolderId,
            calendarEntry.calendarId.id,
            calendarEntry.calendarId.mailboxInfo,
            fontColor,
            calendarEntry.CalendarName
        );
    }
}
